import { merge } from 'lodash';

import { PositionDto, RootPositionDto } from 'api';
import { isMPPurpose } from 'domain/unit/Unit';
import {
	getBlueprintDrivelines,
	getMatchedInstallations,
} from 'domain/unit/structure/GRfunctions';

export const findPosition = (
	id: string,
	position?: PositionDto | RootPositionDto
): PositionDto | RootPositionDto | undefined => {
	let childPosition;

	if (position?.idTemporary === id) {
		return position;
	} else if (!!position?.children) {
		for (const child of position.children) {
			childPosition = findPosition(id, child);

			if (!!childPosition) {
				break;
			}
		}
	}

	return childPosition;
};

export const updatePosition = (
	updatedPosition: Partial<PositionDto>,
	position?: PositionDto | RootPositionDto
): boolean => {
	let isUpdated = false;

	if (position && position?.idTemporary === updatedPosition.idTemporary) {
		merge(position, updatedPosition);

		return true;
	} else if (!!position?.children) {
		for (const child of position.children) {
			isUpdated = updatePosition(updatedPosition, child);

			if (isUpdated) {
				break;
			}
		}
	}

	return isUpdated;
};

export const findAllMPPositions = (
	position?: PositionDto | RootPositionDto
): PositionDto[] =>
	getMatchedInstallations(position as PositionDto)
		.filter((i) =>
			isMPPurpose(i.matchedInstallation!.installationPurposeKey)
		)
		.flatMap((i) => getBlueprintDrivelines(i));
